import { render, staticRenderFns } from "./add-edit.vue?vue&type=template&id=612d2294&scoped=true&"
import script from "./add-edit.vue?vue&type=script&lang=js&"
export * from "./add-edit.vue?vue&type=script&lang=js&"
import style0 from "./add-edit.vue?vue&type=style&index=0&id=612d2294&lang=less&scoped=true&"
import style1 from "./add-edit.vue?vue&type=style&index=1&id=612d2294&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612d2294",
  null
  
)

export default component.exports